import { Injectable, ElementRef } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TooltipService {
  private tooltips = new Map<string, ElementRef>();
  private offsetX = 20;
  private offsetY = 20;

  getCurrentTooltip(componentName: string): ElementRef {
    return this.tooltips.get(componentName)!;
  }

  setTooltipElement(componentName: string, element: ElementRef) {
    this.tooltips.set(componentName, element);
  }

  showTooltip(event: MouseEvent, componentName: string) {
    const tooltip = this.getCurrentTooltip(componentName);
    if (tooltip) {
      tooltip.nativeElement.style.position = 'fixed';
      tooltip.nativeElement.style.zIndex = 1000;
      tooltip.nativeElement.style.top = `${event.clientY + this.offsetY}px`;
      tooltip.nativeElement.style.left = `${event.clientX + this.offsetX}px`;
      tooltip.nativeElement.hidden = false;
    }
  }

  hideTooltip(componentName: string) {
    const tooltip = this.getCurrentTooltip(componentName);
    if (tooltip) {
      tooltip.nativeElement.hidden = true;
    }
  }
}
